import { render } from "./AddTrainSpecies.vue?vue&type=template&id=d26e25a6"
import script from "./AddTrainSpecies.vue?vue&type=script&lang=js"
export * from "./AddTrainSpecies.vue?vue&type=script&lang=js"
script.render = render

export default script